<template>
  <div class="container-fluid mt-0 home-page">
    
    <!-- Welcome Section -->
    <div class="row mb-0 home-welcome">
      <div class="col-12">
        <div class="card border-0 bg-light">
          <div class="card-body d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <span class="welcome-title mr-2">👋 欢迎来到 <router-link to="/contact" class="font-weight-bold text-danger">自在量化</router-link></span>
              <span class="text-muted d-none d-md-inline">| 量化市场一切，欢迎各位提出有效 <router-link to="/feedback" class="font-weight-bold text-primary">建议</router-link>！</span>
            </div>
            <div class="d-flex align-items-center">
               <span class="mr-3 d-none d-sm-inline">
                 感谢 <router-link to="/contact" class="text-danger font-weight-bold">捐赠</router-link> 服务器费用
               </span>
               <WxShare />
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <HomeTopicHighlights />

    <!-- Charts Section -->
    <div class="row chart-grid">
      <!-- Hot Trend Chart -->
      <div class="col-12 col-lg-6 mb-3">
        <div class="card shadow-sm h-100">
          <div class="card-body p-0">
            <component :is="sentimentHotTrend" v-if="showTrend" zoom_start="0"></component>
            <div v-else class="text-center py-5">
              <b-spinner variant="primary" label="Loading..."></b-spinner>
              <p class="mt-2 text-muted">加载中...</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Hot Day Chart -->
      <div class="col-12 col-lg-6 mb-3">
        <div class="card shadow-sm h-100">
          <div class="card-body p-2">
            <component :is="sentimentHotDay" v-if="showDay" zoom_start="45"></component>
            <div v-else class="text-center py-5">
               <b-spinner variant="primary" label="Loading..."></b-spinner>
               <p class="mt-2 text-muted">加载中...</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Index Cards Section (At the very bottom) -->
    <div class="row mb-2">
      <div class="col-12">
        <SentimentIndexMiniCards />
      </div>
    </div>
  </div>
</template>

<script>
import WxShare from '@/components/share/WxShare.vue'
import HomeTopicHighlights from '@/components/home/HomeTopicHighlights.vue'
import SentimentIndexMiniCards from '@/components/sentiment/SentimentIndexMiniCards.vue'

export default {
  name: 'Home',
  components: {
    WxShare,
    HomeTopicHighlights,
    SentimentIndexMiniCards
  },
  data() {
    return {
      sentimentHotTrend: null,
      sentimentHotDay: null,
      showTrend: false,
      showDay: false
    }
  },
  methods: {
    loadTrend() {
      import('components/sentiment/SentimentMarketHotTrend.vue').then(module => {
        this.sentimentHotTrend = module.default;
        this.showTrend = true;
      }).catch(err => {
        console.error("Failed to load trend chart:", err);
      });
    },
    loadDay() {
      import('components/sentiment/SentimentMarketHotDay.vue').then(module => {
        this.sentimentHotDay = module.default;
        this.showDay = true;
      }).catch(err => {
         console.error("Failed to load day chart:", err);
      });
    }
  },
  mounted() {
    this.loadTrend();
    this.loadDay();
  }
}
</script>

<style scoped>
.home-welcome .card-body { min-height:38px; padding:5px 14px; }.welcome-title { font-size:17px; font-weight:600; }.chart-grid { margin-top:0; }
.chart-grid .card { border-color:#e3e8ee; border-radius:8px; overflow:hidden; box-shadow:0 1px 4px rgba(30,45,65,.07)!important; }
.card-body ::v-deep .echarts {
  width: 100% !important;
  height: 300px !important;
}
@media(max-width:650px) { .home-welcome .card-body { padding:5px 9px; }.welcome-title { font-size:15px; } }
</style>
